// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ns-img-empty[data-v-0caec533]{border-radius:6px;position:relative}.ns-img-empty[data-v-0caec533]:after{position:absolute;left:0;right:0;top:0;bottom:0;content:\" \";background:#e6e6e6}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
